import { OutputEmitterRef } from '@angular/core';
import { SmartEnum } from '../../../../../primitives';
import { IActionConfig, IActionExecutedEvent } from '../../types';

export enum ActionTypeHandlerEnum {
  DIALOG = 'Dialog',
  REDIRECT = 'Redirect',
  CUSTOM_EXECUTOR = 'CustomExecutor'
}

export class ActionTypeHandlerBaseSmartEnum extends SmartEnum<ActionTypeHandlerBaseSmartEnum> {
  constructor(name: string) {
    super(name);
  }

  execute<TEntity, TComponentType = unknown, TData = unknown>(
    config: IActionConfig<TEntity, TComponentType, TData>,
    item?: TEntity,
    actionExecuted?: OutputEmitterRef<IActionExecutedEvent<TEntity>>
  ) {
    throw new Error(`you can't use this method from here`);
  }
}
